import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { REFERENCE_FEATURE, ReferenceState, StateWithReference } from '../reference-state';

export const getReferenceFeatureState: MemoizedSelector<StateWithReference, ReferenceState> =
  createFeatureSelector<ReferenceState>(REFERENCE_FEATURE);
